export const LookupAddressListStyles = {
  topItem: 'pt-2',
  container: 'border-gray50 border rounded bg-white text-gray shadow-md',
}
